import { richTextResolver } from '@storyblok/richtext'
const storyblokRichText = richTextResolver()
export { storyblokRichText }
